<template>
  <li class="download-list-item download-list-item--unapproved">
    <div class="download-list-item__icon download-list-item__icon--primary">
      <i class="fa fa-2x" :class="getFileIcon"></i>
    </div>
    <div class="download-list-item__block" v-if="this.is_offer">
      <p class="download-list-item__label">
        {{ file.file_name }}
      </p>
      <p class="download-list-item__link">
        <span @click="this.handleDownloadFileCallback">
          <i class="fa fa-cloud-download"></i> Download File
        </span>
      </p>
    </div>
    <div class="download-list-item__block" v-else>
      <p class="download-list-item__label">
        {{ file.name }}
        <span class="download-list-item__label--unapproved"> - {{ fileLastUpdated | date($user.date_format_preference) }}</span>
      </p>
    </div>
    <div class="download-list-item__icon download-list-item__icon--secondary items-center">
      <i class="fa fa-times" @click="this.handleDeleteFileCallback"></i>
    </div>
  </li>
</template>

<script>
import moment from 'moment-timezone'

export default {
  props: {
    file: {
      required: true
    },
    booking: {
      required: true
    }
  },

  computed: {
    fileLastUpdated () {
      return moment.utc(this.file.updated_at).local()
    },

    getFileIcon () {
      let type = this.file.type.split('/')
      type = type[type.length - 1]

      switch (type) {
        case ('png'):
        case ('jpg'):
          return 'fa-file-image-o'
        case ('pdf'):
          return 'fa-file-pdf-o'
        case ('doc'):
        case ('docx'):
          return 'fa-file-word-o'
        case ('zip'):
          return 'fa-file-archive-o'
        case ('ppt'):
        case ('pptx'):
          return 'fa-file-powerpoint-o'
        case ('csv'):
        case ('xls'):
        case ('xlsx'):
          return 'fa-file-excel-o'
        default:
          return 'fa-file-o'
      }
    }
  },

  methods: {
    handleDeleteFileCallback () {
      this.booking.files = this.booking.files.filter(f => f.name !== this.file.name)
    }
  }
}
</script>

<style type="scss" scoped>
  .download-list-item__icon {
    align-items: start;
    margin-top: 5px;
    margin-right: 15px;
  }

  .items-center {
    margin-top: 0;
    align-items: center !important;
  }
</style>
